"use client";

import Link from "next/link";
import { track } from "@/lib/analytics";

export default function OutboundLink({
  href,
  location,
  extra = {},
  className,
  children,
  ...props
}) {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={() =>
        track("outbound_click", {
          href: String(href),
          location,
          ...extra,
        })
      }
      {...props}
    >
      {children}
    </Link>
  );
}
